
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Login from './pages/Login';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import SegmentationExplorer from './pages/SegmentationExplorer';
import CampaignManagement from './pages/CampaignManagement';
import Competitor360 from './pages/Competitor360';
import TradeAreaAnalyzer from './pages/TradeAreaAnalyzer';
import Documentation from './pages/Documentation';
import ToastProvider from './components/ToastProvider';
import { AIAgentProvider } from './context/AIAgentContext';
import AIAgentToggle from './components/ai-agent/AIAgentToggle';
import AIAgentPanel from './components/ai-agent/AIAgentPanel';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './App.css';

const PageLayout = ({ children }) => {
  const location = useLocation();
  
  // Add page-specific class names
  const getPageClass = () => {
    const pathName = location.pathname;
    if (pathName.includes('segmentation-explorer')) {
      return 'segmentation-page';
    }
    return '';
  };
  
  return (
    <div className={`flex h-screen bg-gray-50 ${getPageClass()}`}>
      <Navigation />
      <main className="flex-1 overflow-auto">
        <div className="h-full w-full max-w-full">
          {children}
        </div>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ToastProvider>
        <AIAgentProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <PageLayout>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/executive-dashboard" element={<ExecutiveDashboard />} />
                      <Route path="/segmentation-explorer" element={<SegmentationExplorer />} />
                      <Route path="/campaign-management" element={<CampaignManagement />} />
                      <Route path="/competitor-360" element={<Competitor360 />} />
                      <Route path="/trade-area-analyzer" element={<TradeAreaAnalyzer />} />
                      <Route path="/documentation" element={<Documentation />} />
                    </Routes>
                    <AIAgentToggle />
                    <AIAgentPanel />
                  </PageLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </AIAgentProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
